function noop(any) {
  return any;
}

export { noop };